import { appRoles } from 'core/auth/auth.constants';

export interface BaseRoutes {
  root: string;
}

const baseRoutes: BaseRoutes = {
  root: '/',
};

export const switchRoutes: BaseRoutes = { ...baseRoutes };
export const linkRoutes: BaseRoutes = { ...baseRoutes };

export const routeRoleMapping = {
  [switchRoutes.root]: [appRoles.POCC_ADMIN],
};
